export const MAX_AMOUNT = '0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff';
export const ADDRESS_ZERO = '0x0000000000000000000000000000000000000000';
export const DAI_PERMIT_TYPEHASH =
  '0xea2aa0a1be11a07ed86d755c93467f4f82362b452371d1ba94d1715123511acb';
export const EIP_2612_PERMIT_TYPEHASH =
  '0x6e71edae12b1b97f4d1f60370fef10105fa2faae0126114a169c64845d6126c9';
export const EIP_2612_DOMAIN_TYPEHASH =
  '0x8b73c3c69bb8fe3d512ecc4cf759cc79239f7b179b0ffacaa9a75d522b39400f';
export const UNISWAP_DOMAIN_TYPEHASH =
  '0x8cad95687ba82c2ce50e74f7b754645e5117c3a5bec8151c0726d5857980a866';
export const _GLOBAL_INDEX_MAINNET_FLAG = BigInt(2 ** 64);
export enum Permit {
  DAI = 'DAI',
  EIP_2612 = 'EIP_2612',
  UNISWAP = 'UNISWAP'
}
